var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDropdownDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7071 15.6911C18.3166 16.103 17.6834 16.103 17.2929 15.6911L12 10.1092L6.70711 15.6911C6.31658 16.103 5.68342 16.103 5.29289 15.6911C4.90237 15.2793 4.90237 14.6115 5.29289 14.1997L10.5858 8.61777C11.3668 7.79408 12.6332 7.79408 13.4142 8.61777L18.7071 14.1997C19.0976 14.6115 19.0976 15.2793 18.7071 15.6911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdownDown);
export default __webpack_public_path__ + "static/media/ic_dropdown-down.568092f8cb09fa90f8d27565aea71232.svg";
export { ForwardRef as ReactComponent };